<template>
  <div class="map" id="map" ref="map"></div>
</template>

<script>
  import moment from 'moment'

  export default {
    name: 'Map',
    data () {
      return {
        platform: {},
        map: null,

        behavior: null,
        ui: {},
        defaultLayers: null,
        events: null,

        openedBubbleInstance: null,

        marqueurBus: null,
        marqueurArret: {},
        currentArret: {},

        iconeBus: '',
        iconeArret: '',

        groupMarker: null,
        groupBounding: null,

        shapeLoadingDone: false,
        stopsLoadingDone: false,
        interactionUser: false,

        routeColor: null,

        timeStampCalcule: null
      }
    },

    props: [
      'busReset', 'coordonnees', 'positionArret', 'shape'
    ],

    watch: {
      'coordonnees': function () {
        this.forceUpdateCordonnees()
        if (this.positionArret !== null) {
          this.forceBoundMap()
        }
        this.timeStampDepasse()
      },
      'positionArret': function () {
        if (this.positionArret !== null) {
          this.routeColor = '#' + this.positionArret.routeColor

          // Icône pour les arrêts à afficher sur la shape
          let icon = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" width="200" height="200">` +
            `<circle cx="100" cy="100" r="80" fill="white" stroke-width="40" stroke="strokeColor"/>` +
            `</svg>`
          this.iconeArrets = new H.map.Icon(icon.replace('strokeColor', this.routeColor), {
            size: {
              w: 12,
              h: 12
            },
            anchor: {
              x: 6,
              y: 6
            }
          })

          this.addMarkerArret()

          // On valide le loading des arrêts et on affiche si la shape est loadée
          this.stopsLoadingDone = true
          this.createAndDisplayShapeAndStops(this.shapeLoadingDone, this.stopsLoadingDone)
          this.mapCenter(this.positionArret.latitude, this.positionArret.longitude, true)
        }
      },
      'busReset': function () {
        this.resetMarker()
      },
      'shape': function () {
        // condition pour éviter d'essayer l'affichage d'une shape si elle ne comporte aucunes données
        if (typeof this.shape !== 'undefined' && this.shape !== null && this.shape.length !== null && this.shape.length > 0) {
          // On valide le loading de la shape et on l'affiche si les arrêts sont loadés
          this.shapeLoadingDone = true
          this.createAndDisplayShapeAndStops(this.shapeLoadingDone, this.stopsLoadingDone)
        }
      }
    },

    methods: {
      forceBoundMap: function () {
        // On ne bound la map seulement si aucune bubble n'est ouverte
        if ((this.openedBubbleInstance === null || this.openedBubbleInstance.getState() !== 'open') && this.interactionUser === false) {
          let data = { bounds: this.groupBounding.getBoundingBox() }
          this.map.getViewModel().setLookAtData(data, true)
        }
      },

      createAndDisplayShapeAndStops: function (shape, stops) {
        if (shape && stops) {
          this.createShape(this.shape)
          this.addMarkersOtherArrets()
        }
      },

      // Création d'un trajet sur la map
      createShape: function (shapes) {
        console.log('nombre de points dans la shape :' + shapes.length)
        // Initialise la linePoints et y ajouter tous les listePoints:
        let linePoints = new H.geo.LineString()
        shapes.forEach(function (shape) {
          linePoints.pushLatLngAlt(shape.shape_pt_lat, shape.shape_pt_lon, null)
        })
        // Initialise le trajet avec du 'css':
        let trajet = new H.map.Polyline(linePoints, {
          style: {
            lineWidth: 4,
            strokeColor: this.routeColor,
            lineCap: 'arrow-head'
          }
        })
        // Ajoute le trajet à la map:
        this.map.addObject(trajet)
      },

      // Création du marqueurBus et ajout dans le groupe de marqueur
      addMarkerBus: function () {
        if (this.coordonnees !== null) {
          this.marqueurBus = new H.map.Marker({
            lng: this.coordonnees.longitude,
            lat: this.coordonnees.latitude
          }, {
            icon: this.iconeBus
          })
          // this.groupMarker.addObject(this.marqueurBus)
          this.groupBounding.addObject(this.marqueurBus)
        }
      },

      // Création du marqueurArrêt et ajout dans le groupe de marqueur
      addMarkerArret: function () {
        this.marqueurArret = new H.map.Marker({
          lng: this.positionArret.longitude,
          lat: this.positionArret.latitude
        }, {
          icon: this.iconeArret
        })
        // this.groupMarker.addObject(this.marqueurArret)
        this.groupBounding.addObject(this.marqueurArret)
        this.marqueurArret.addEventListener('tap', this.createBulleArretCurrent)
      },

      addMarkersOtherArrets: function () {
        this.positionArret.arrets.forEach(item => {
          let self = this
          let arret = new H.map.Marker({
            lng: item.longitude,
            lat: item.latitude
          }, {
            // Par défaut l'index est à 0; Les icônes des autres arrêts seront donc en troisième plan
            icon: this.iconeArrets
          })
          this.groupMarker.addObject(arret)
          arret.addEventListener('tap', function () { self.createBulleArretOthers(item) })
        })
      },

      // Fonction permettant de mettre à jour les coordonnées GPS sur le marqueur de la map
      forceUpdateCordonnees: function () {
        if (this.groupBounding !== null) {
          let that = this
          this.groupBounding.getObjects().forEach(function (bus) {
            if (bus === that.marqueurBus) {
              that.groupBounding.removeObject(that.marqueurBus)
            }
          })
          if (this.coordonnees !== null) {
            this.addMarkerBus()
          }
        }
      },

      // Choix du centrage de la map
      mapCenter: function (latitude, longitude, animationNeeded) {
        // on centre la map sur les coordonnées souhaités avec le paramètre 'animation' à true
        this.map.setCenter({
          lat: latitude,
          lng: longitude
        }, animationNeeded)
      },

      addMarkerAndSetViewBounds: function () {
        this.forceUpdateCordonnees()
        this.groupMarker = new H.map.Group({zIndex: 0})
        this.groupBounding = new H.map.Group({zIndex: 1})
        this.map.addObject(this.groupBounding)
        this.map.addObject(this.groupMarker)
      },

      // disparition du marqueur si la position récupérée est trop ancienne
      timeStampDepasse: function () {
        if (this.coordonnees.timestamp !== null) {
          let timeStamp = moment(this.coordonnees.timestamp, 'YYYY-MM-DD hh:mm:ss Z')
          if (timeStamp < moment().subtract(1, 'minute')) {
            console.log('Position trop ancienne : ' + this.coordonnees.timestamp)
            this.groupBounding.removeObject(this.marqueurBus)
          }
        }
      },

      createBulleArretCurrent: function () {
        let bubble = new H.ui.InfoBubble({
          lng: this.positionArret.longitude,
          lat: this.positionArret.latitude
        }, {
          content: '<div style="width: 240px;">' +
            '<div style="font-size: 20px; font-weight: bold; color: #4c4a49; font-family: \'M PLUS Rounded 1c\', sans-serif; text-align: center;">Arrêt ' + this.positionArret.stopName + '</div>' +
            '<div style="margin-top: 10px; display: block; text-align: center;">' +
            '<a style="color: #e84e07; font-family: \'Roboto\';" href="https://www.neobus-ccov.fr/#/arret=' + this.positionArret.stopName + '">Prochains passages <i class="fas fa-arrow-circle-right"></i></a>' +
            '</div>' +
            '</div>'
        })

        let ui = H.ui.UI.createDefault(this.map, this.defaultLayers, 'fr-FR')

        if (this.openedBubbleInstance !== null && this.openedBubbleInstance.getState() === 'open') {
          this.openedBubbleInstance.close()
          this.openedBubbleInstance.dispose()
        }
        this.openedBubbleInstance = bubble
        ui.addBubble(bubble)
        this.mapCenter(this.positionArret.latitude, this.positionArret.longitude, true)
      },

      createBulleArretOthers: function (item) {
        let bubble = new H.ui.InfoBubble({
          lng: item.longitude,
          lat: item.latitude
        }, {
          content: '<div style=" width: 240px;">' +
            '<div style="font-size: 20px; font-weight: bold; color: #4c4a49; font-family: \'M PLUS Rounded 1c\', sans-serif; text-align: center;">Arrêt ' + item.stopName + '</div>' +
            '<div style="margin-top: 10px; display: block; text-align: center;">' +
            '<a style="color: #e84e07; font-family: \'Roboto\';" href="https://www.neobus-ccov.fr/#/arret=' + this.positionArret.stopName + '">Suivre cet arrêt <i class="fas fa-arrow-circle-right"></i></a>' +
            '</div>' +
            '</div>'
        })

        let ui = H.ui.UI.createDefault(this.map, this.defaultLayers, 'fr-FR')

        if (this.openedBubbleInstance !== null && this.openedBubbleInstance.getState() === 'open') {
          this.openedBubbleInstance.close()
          this.openedBubbleInstance.dispose()
        }
        this.openedBubbleInstance = bubble
        ui.addBubble(bubble)
        this.mapCenter(item.latitude, item.longitude, true)
      },

      interactionUserEvents: function () {
        let that = this
        this.map.addEventListener(['dbltap', 'drag', 'wheel'], function () { that.interactionUser = true })
      },

      resetMarker: function () {
        if (this.busReset === true) {
          console.log('Le bus doit disparaître de la map !')
          this.map.removeObject(this.marqueurBus)
        }
      }
    },

    mounted () {
      // clé API d'Here
      this.platform = new H.service.Platform({
        'apikey': process.env.API_KEY_HERE
      })

      this.defaultLayers = this.platform.createDefaultLayers()

      // Création de la map en initialisant le zoom et un padding pour l'affichage entier des marqueurs
      this.map = new H.Map(
        this.$refs.map,
        this.defaultLayers.vector.normal.map,
        {
          zoom: 12,
          padding: {
            top: 80,
            left: 80,
            bottom: 80,
            right: 80
          },
          pixelRatio: window.devicePixelRatio || 1
        }
      )

      // On centre sur Toul par défaut en attendant le chargement afin d'éviter la première animation un peu longue
      this.mapCenter('48.356059', '5.693754', false)

      // Refresh de la carte quand on resize la page
      window.addEventListener('resize', () => this.map.getViewPort().resize())

      // Interaction Carte-Utilisateur (Boutons zoom -/+ et vue satellite)
      this.events = new H.mapevents.MapEvents(this.map)
      this.behavior = new H.mapevents.Behavior(this.events)
      this.ui = H.ui.UI.createDefault(this.map, this.defaultLayers, 'fr-FR')

      this.interactionUserEvents()

      // Création des icones avec une image curseur et en définissant sa taille
      this.iconeBus = new H.map.Icon(require('../assets/marqueurBus.svg'), {
        size: {
          w: 45,
          h: 55
        }
      })
      this.iconeArret = new H.map.Icon(require('../assets/marqueurArret.svg'), {
        size: {
          w: 45,
          h: 55
        }
      })

      this.map.draggable = true

      this.addMarkerAndSetViewBounds(this.map)
      this.resetMarker()
    }
  }
</script>

<style scoped lang="scss">
@import "../sass/variables";
@import "../../node_modules/bootstrap/scss/bootstrap";

.map {
  margin: auto auto 1rem auto;
  width: 600px;
  height: 500px;
  clip-path: inset(0% round 25px);
  @include media-breakpoint-down(sm) {
    width: 100%;
    height: 400px;
  }

  @include media-breakpoint-down(lg) {
    margin-bottom: 1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Map.vue